import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import { ROLE } from "../../enums/rolesEnum";
import { LayoutContainer } from "../../layout/LayoutContainer/LayoutContainer";
import { getUserData } from "../../utils/FunctionHelpers";
import { getCvBlob } from "../Services/FileService";
import { getDetails } from "../Services/UserService";
import ProfileHeader from "./Components/ProfileHeader";
import ProgressSection from "./Components/ProgressSection";
import RecentActivity from "./Components/RecentActivity";
import RecentTasks from "./Components/RecentTasks";
import "./profile.css";

const FULL_PROFILE_ROLES = [ROLE.ROLE_ADMIN, ROLE.ROLE_CONSULTANT];

const Profile = () => {
  const user = getUserData();
  const userRoles = Array.isArray(user?.role) ? user.role : user?.role ? [user.role] : [];
  const hasFullProfile = userRoles.some((role) => FULL_PROFILE_ROLES.includes(role));
  const [details, setDetails] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uuid) {
      setLoading(false);
      return;
    }
    getDetails(user.uuid)
      .then(({ data }) => setDetails(data))
      .catch(() => setDetails(null))
      .finally(() => setLoading(false));
  }, [user?.uuid]);

  useEffect(() => {
    if (!user?.image) return;
    getCvBlob(user.image)
      .then(({ data }) => {
        const reader = new FileReader();
        reader.onloadend = () => setImageUrl(reader.result);
        reader.readAsDataURL(data);
      })
      .catch(() => setImageUrl(null));
  }, [user?.image]);

  if (loading) return <Loader />;

  return (
    <LayoutContainer>
      <Box className="profilePage">
        <Box className="profileTitleWrap">
          <Typography className="profileTitle">MON PROFIL</Typography>
        </Box>

        <ProfileHeader
          user={user}
          email={details?.email}
          fonction={details?.fonction}
          isActive={details?.isActive}
          imageUrl={imageUrl}
        />
        {hasFullProfile && (
          <>
            <Grid container spacing={2} sx={{ marginTop: "0px" }}>
              <Grid item xs={12} md={8}>
                <RecentActivity />
              </Grid>
              <Grid item xs={12} md={4}>
                <RecentTasks />
              </Grid>
            </Grid>
            <ProgressSection />
          </>
        )}
      </Box>
    </LayoutContainer>
  );
};

export default Profile;
